import styled from 'styled-components'
import { Heading } from '@notino/react-styleguide'

// components
import DefaultContainer from '../../components/DefaultContainer/DefaultContainer'

// styles
import { BREAKPOINTS } from '../../styles/constants'
import { screenReaderOnly } from '../../styles/helpers'

export const SeoTitle = styled.h1`
	${screenReaderOnly};
`

export const PageContainer = styled(DefaultContainer)`
	position: relative;
`

export const MainTitle = styled(Heading.H1)`
	font-weight: 500;
	margin-top: 4px;
	margin-bottom: 16px;
	text-align: left !important; // override for notino global styles
`

export const MainContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;

	@media (min-width: ${BREAKPOINTS.sm}) {
		gap: 40px;
	}
`

export const ReservationsContainer = styled.div``

export const SubTitle = styled(Heading.H2)`
	font-weight: 500;
	font-size: 1rem;
	line-height: 1.5rem;
	margin-top: 0;
	margin-bottom: 10px;
	text-align: left !important; // override for notino global styles

	@media (min-width: ${BREAKPOINTS.sm}) {
		padding: 4px 0;
		margin-bottom: 20px;
		font-size: 1.25rem;
		line-height: 1.875rem;
	}
`
